import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=b68b0258&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b68b0258')) {
      api.createRecord('b68b0258', component.options)
    } else {
      api.reload('b68b0258', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=b68b0258&", function () {
      api.rerender('b68b0258', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2t2QgXHCxwQQP/JS/comp/ImgFallback.vue"
export default component.exports